// Instantiate Lazyload for elements with background.
import LazyLoad from "vanilla-lazyload";
import { Popover } from "bootstrap";
if (!window.lazyLoadInstance) {
  window.lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy"
  });
}

document.addEventListener('DOMContentLoaded', function () {
  let isMobile = setIsMobile(window.innerWidth);

  function setIsMobile(width) {
    return width < 768;
  }

  window.addEventListener('resize', function () {
    isMobile = setIsMobile(window.innerWidth);
  });

  // FAQ.
  document.querySelectorAll('.faq-accordion-item').forEach(function (item) {
    item.addEventListener('click', function (event) {
      event.preventDefault();

      const answer = this.querySelector(':scope > .faq-accordion-content');
      if (!answer) return;

      if (answer.style.display === 'block') {
        answer.style.display = 'none';
      } else {
        answer.style.display = 'block';
      }

      this.classList.toggle('open');
    });
  });

  function setScrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);

    const inner = document.createElement('div');
    outer.appendChild(inner);

    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    outer.parentNode.removeChild(outer);
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  }
  setScrollbarWidth();

  //Set css variables for CTA slider.
  const sliderVariables = {
    sidebar: document.querySelector('aside'),
    container: document.querySelector('.container')
  };

  function setSliderVariables(elements) {
    const sidebarWidth = elements.sidebar ? elements.sidebar.offsetWidth : 0;
    const containerWidth = elements.container ? elements.container.offsetWidth : 0;

    document.documentElement.style.setProperty('--sidebar-width', `${sidebarWidth}px`);
    document.documentElement.style.setProperty('--container-width', `${containerWidth}px`);
  }
  setSliderVariables(sliderVariables);

  window.addEventListener('resize', () => {
    setSliderVariables(sliderVariables);
  });

  // Header.
  const header = document.getElementById('header');
  let scrollOffset = window.scrollY;

  function checkScroll(scrollOffset) {
    if (scrollOffset >= 1) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }
  checkScroll(scrollOffset);

  window.addEventListener('scroll', () => {
    scrollOffset = window.scrollY;
    checkScroll(scrollOffset);
  });

  //Footer menu.
  document.querySelectorAll('.footer-menu > li > a').forEach(function (item) {
    item.addEventListener('click', function (event) {
      event.preventDefault();

      if (isMobile) {
        this.parentElement.classList.toggle('has-background');
        this.classList.toggle('open');
        this.nextElementSibling.style.display = this.classList.contains('open') ? 'block' : 'none';
      }
    });
  });

  //Sitemap.
  document.querySelectorAll('.sitemap ul li.page_item_has_children > a').forEach(function (link) {
    const span = document.createElement('span');

    span.addEventListener('click', function (event) {
      event.preventDefault();

      this.classList.toggle('open');

      const subMenu = link.nextElementSibling;
      console.log(link.nextElementSibling);

      if (subMenu && subMenu.tagName === 'UL') {
        if (subMenu.style.display === 'block') {
          subMenu.style.display = 'none';
        } else {
          subMenu.style.display = 'block';
        }
      }
    });

    link.prepend(span);
  });

  document.querySelectorAll('.sitemap .tab-content ul li a').forEach(function (link) {
    const span = document.createElement('span');

    span.className = 'path-name';
    span.textContent = link.pathname;
    link.appendChild(span);
  });

  //Textarea in contact page.
  document.querySelectorAll('.contact-us-form textarea').forEach(function (textarea) {
    textarea.addEventListener('input', () => {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 2 + 'px';
    });
  });

  //Manual removal if necessary "Was this helpful?" (does not work correctly with the WP Rocket cache plugin).
  const wasThisHelpfulDiv = document.getElementById('was-this-helpful');

  if (wasThisHelpfulDiv) {
    const helpfulId = wasThisHelpfulDiv.getAttribute('data-post-id');
    const cookieName = 'helpful_id_' + helpfulId;
    const cookieExists = document.cookie.indexOf(cookieName) !== -1;

    if (cookieExists) {
      wasThisHelpfulDiv.parentNode.removeChild(wasThisHelpfulDiv);
    }
  }

  //Was this helpful? Feedback form logic.
  const noButton = document.querySelector('#wthf-yes-no span[data-value="0"]');
  const feedbackForm = document.querySelector('#was-this-helpful .wpcf7');
  const feedback = document.querySelector('#was-this-helpful .wpcf7 textarea');
  const submitButton = document.querySelector('#was-this-helpful .wpcf7-submit');
  const closeButton = document.querySelector('#was-this-helpful .wpcf7 button');

  if (noButton && feedbackForm && feedback && submitButton && closeButton) {
    const feedbackIsEmpty = (textarea) => {
      return textarea.value.length === 0;
    };

    noButton.addEventListener('click', () => {
      document.body.classList.add('feedback-form-open');
      feedbackForm.style.display = 'block';
    });

    closeButton.addEventListener('click', () => {
      document.body.classList.remove('feedback-form-open');
      feedbackForm.style.display = 'none';
    });

    submitButton.disabled = feedbackIsEmpty(feedback);

    feedback.addEventListener('input', function () {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 2 + 'px';

      submitButton.disabled = feedbackIsEmpty(this);
    });
  }

  // Block GB "Card" add stretched link class.
  document.querySelectorAll('.gb-card').forEach(function (item) {
    const link = item.querySelector('a');
    if (link) {
      link.classList.add('stretched-link');
    }
  });

  // Bootstrap 5 popovers (vanilla JS, no jQuery).
  const popoverEls = document.querySelectorAll('[data-bs-toggle="popover"]');
  popoverEls.forEach(function (el) {
    const popover = new Popover(el, {
      trigger: 'hover',
      html: true,
      sanitize: false,
      placement: 'auto',
      container: 'body',
      animation: true,
      delay: { show: 500, hide: 400 }
    });
    el.addEventListener('hide.bs.popover', function (e) {
      if (document.querySelector('.popover:hover')) {
        e.preventDefault();
      }
    });
  });
  document.body.addEventListener('mouseleave', function (e) {
    if (e.target.classList && e.target.classList.contains('popover')) {
      popoverEls.forEach(function (el) {
        const inst = Popover.getInstance(el);
        if (inst) {
          inst.hide();
        }
      });
    }
  }, true);
});